import { actions } from './actions'

const initialState = {
  restriccionesEntrega: {
    data: [],
    loading: false,
    error: null,
  },
  restriccionEntrega: {
    data: null,
    loading: false,
    error: null,
  },
}

export default function restriccionEntregaReducer(state = initialState, action) {
  switch (action.type) {
    // Cargar lista de restricciones
    case actions.RESTRICCIONES_ENTREGA_LOAD_REQUESTED:
      return {
        ...state,
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          loading: true,
          error: null,
        },
      }
    case actions.RESTRICCIONES_ENTREGA_LOAD_SUCCEEDED:
      return {
        ...state,
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          data: action.payload,
          loading: false,
          error: null,
        },
      }
    case actions.RESTRICCIONES_ENTREGA_LOAD_FILED:
      return {
        ...state,
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          loading: false,
          error: action.payload,
        },
      }

    // Cargar restricción por ID
    case actions.RESTRICCION_ENTREGA_BYID_LOAD_REQUESTED:
      return {
        ...state,
        restriccionEntrega: {
          ...state.restriccionEntrega,
          loading: true,
          error: null,
        },
      }
    case actions.RESTRICCION_ENTREGA_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        restriccionEntrega: {
          ...state.restriccionEntrega,
          data: action.payload,
          loading: false,
          error: null,
        },
      }
    case actions.RESTRICCION_ENTREGA_BYID_LOAD_FILED:
      return {
        ...state,
        restriccionEntrega: {
          ...state.restriccionEntrega,
          loading: false,
          error: action.payload,
        },
      }

    // Insertar restricción
    case actions.RESTRICCION_ENTREGA_INSERT_REQUESTED:
      return {
        ...state,
        restriccionEntrega: {
          ...state.restriccionEntrega,
          loading: true,
          error: null,
        },
      }
    case actions.RESTRICCION_ENTREGA_INSERT_SUCCEEDED:
      return {
        ...state,
        restriccionEntrega: {
          ...state.restriccionEntrega,
          loading: false,
          error: null,
        },
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          data: [...state.restriccionesEntrega.data, action.payload],
        },
      }
    case actions.RESTRICCION_ENTREGA_INSERT_FILED:
      return {
        ...state,
        restriccionEntrega: {
          ...state.restriccionEntrega,
          loading: false,
          error: action.payload,
        },
      }

    // Insertar restricciones en lote
    case actions.RESTRICCION_ENTREGA_INSERT_BULK_REQUESTED:
      return {
        ...state,
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          loading: true,
          error: null,
        },
      }
    case actions.RESTRICCION_ENTREGA_INSERT_BULK_SUCCEEDED:
      return {
        ...state,
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          loading: false,
          error: null,
        },
      }
    case actions.RESTRICCION_ENTREGA_INSERT_BULK_FILED:
      return {
        ...state,
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          loading: false,
          error: action.payload,
        },
      }

    // Eliminar restricciones en lote
    case actions.RESTRICCION_ENTREGA_DELETE_BULK_REQUESTED:
      return {
        ...state,
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          loading: true,
        },
      }

    case actions.RESTRICCION_ENTREGA_DELETE_BULK_SUCCEEDED:
      return {
        ...state,
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          loading: false,
        },
      }

    case actions.RESTRICCION_ENTREGA_DELETE_BULK_FILED:
      return {
        ...state,
        restriccionesEntrega: {
          ...state.restriccionesEntrega,
          loading: false,
          error: action.payload,
        },
      }

    default:
      return state
  }
}
